<template>
  <div class="pt-0" style="padding-left: 2%; padding-right: 2%; background-color: #F8F9FA; padding-bottom: 2%; min-height: 100vh;">
    <v-row class="mb-2">
      <v-col cols="6">
        <img width="17" height="17" src="@/assets/icons/back-icon.png" class="mt-5 ml-0" style="cursor: pointer;" @click="goBack()">
        <span class="header-title ml-0">
          รายละเอียดใบร้องขอ
        </span>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 d-flex align-center justify-end mt-4 action-top-btn">
        <v-btn v-if="editMode === true" width="18%" class="ma-2 mr-5" color="#3776E9" dark @click="dialogConfirmSubmit = true">บันทึกข้อมูล</v-btn>
        <v-btn v-if="editMode === false && approveRole === 'Super Admin'" width="12%" class="ma-2 mr-3" outlined color="#3776E9" dark @click="changeMode()">แก้ไข</v-btn>
        <v-btn v-else-if="editMode === true" width="20%" class="ma-2 mr-3" outlined color="#3776E9" dark @click="changeMode()">ยกเลิกการแก้ไข</v-btn>
        <!-- <v-btn width="18%" class="ma-0" outlined color="#3776E9" dark @click="cancel()">ยกเลิก</v-btn> -->
      </v-col>
    </v-row>
    <v-card height="auto" min-height="82vh" class="pt-7 pb-7" >
      <v-container fluid pa-0 >
          <v-row align="center" justify="center" >
          <div class="update-chart-full pt-1 pb-4 rounded-0" style="min-width:50vw; width:50vw; max-width:90vw;">
            <div class="text-left">
              <span class="txt-head text--darken-4 font-weight-bold mr-5 text-title-content">ข้อมูล</span>
            </div>
            <v-divider class="mt-1 mb-4"/>
            <div class="text-center mt-1" justify="start">
              <v-row class="mb-0" align="center" style="margin-top: 0px;">
                <v-col cols="12" lg="6" md="6" class="text-left" style="margin-top: -5px;">
                  <span class="grey--text text-darken-4 mt-1 mb-1">ชื่อโปรเจค</span><br>
                  <span v-if="editMode === false" class="black--text mt-1 mb-1">{{ dataSource.projectName || '-' }}</span>
                  <v-text-field
                  v-else
                  v-model="dataSource.projectName"
                  outlined
                  dense
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="mb-0" align="center" style="margin-top: 2px;">
                <v-col cols="12" lg="12" md="12" class="text-left" style="margin-top: -5px;" align-self="end">
                  <span class="grey--text text-darken-4 mt-1 mb-1">Token</span><br>
                  <v-text-field
                    v-model="token"
                    outlined
                    dense
                    readonly
                    background-color="#FAFAFA"
                    v-if="token"
                  >
                    <template slot="append-outer">
                      <v-tooltip bottom style="cursor: pointer;">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="ra-border-button"
                            style="margin-top: -8px;"
                            height="40"
                            v-bind="attrs"
                            v-on="on"
                            color="primary"
                            icon
                            :disabled="false"
                            @click="copyToken"
                          >
                          <v-icon color="#2BA197" >mdi-content-copy</v-icon>
                          </v-btn>
                        </template>
                        <span class="label-table-action">คัดลอก Token</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                  <span v-else class="black--text mt-1 mb-1">-</span>
                </v-col>
              </v-row>
              <v-row class="mb-0" align="center" style="margin-top: 5px;">
                <v-col cols="12" lg="6" md="6" class="text-left" style="margin-top: -5px;">
                  <span class="grey--text text-darken-4 mt-1 mb-1">หมายเหตุ</span><br>
                  <span v-if="editMode === false" class="black--text mt-1 mb-1">{{ dataSource.comment || '-' }}</span>
                  <v-textarea
                  v-else
                  v-model="dataSource.comment"
                  outlined
                  dense
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row class="mb-0" align="center" style="margin-top: 5px;">
                <v-col cols="12" lg="6" md="6" class="text-left" style="margin-top: -5px;">
                  <span class="grey--text text-darken-4 mt-1 mb-1">ความเห็นผู้อนุมัติ</span><br>
                  <span class="black--text mt-1 mb-1">{{ dataSource.commentRequest || '-' }}</span>
                </v-col>
              </v-row>
              <v-row class="mb-0" align="center" style="margin-top: 10px;" v-if="approvers.length">
                <v-col cols="12" lg="12" md="12" class="text-left" style="margin-top: 5px;">
                  <div class="">
                    <span class="txt-head text--darken-4 font-weight-bold mr-5 text-title-content ">รายละเอียดผู้ร้องขอ</span>
                  </div>
                  <v-divider class="mt-1 mb-4"/>
                </v-col>
              </v-row>
              <v-row class="mb-0" align="center" style="margin-top: -10px;"
                v-if="approvers.length"
              >
                <v-col cols="12" lg="12" md="12" class="text-left" style="margin-top: 5px;"
                  v-for="item in approvers"
                  :key="item.approverNo"
                >
                  <v-card
                      class="user-data-panel"
                      style="margin-top: -14px;"
                      outlined
                    >
                    <!-- <v-row class="pl-1 ml-0 mr-0 pr-1 pt-0 user-data-panel">
                      <v-card flat outlined class="ra-head-text-gray blue--text text--darken-3 pl-1 pr-1 mt-1 mb-1">ลำดับที่ {{item.approverNo}}</v-card>
                    </v-row> -->
                    <v-row class="pl-1 pr-1 pt-0">
                      <v-col cols="12" sm="2" md="2" lg="2" class="">
                        <v-avatar
                          class="ml-3 mt-0"
                          :size="$vuetify.breakpoint.name !== 'lg'? '70':'70'"
                          rounded
                        >
                        <v-img
                          cover
                          :lazy-src="require('@/assets/icons/no_user.png')"
                          :src="item.userImg? item.userImg : require('@/assets/icons/no_user.png')"
                        >
                        </v-img>
                        </v-avatar>
                      </v-col>
                      <v-col cols="12" sm="10" md="10" lg="10" style="margin-top: -10px; margin-bottom: -10px;">
                        <v-row class="">
                          <v-col cols="12" lg="5" md="5" sm="5" class="ma-0 pb-0">
                            <span class="ra-head-text-gray">รหัสพนักงาน: </span>
                            <span class="ra-head-text black--text">{{ item.employeeId }}</span>
                          </v-col>
                          <v-col cols="12" lg="7" md="7" sm="7" class="ma-0 pb-2">
                            <span class="ra-head-text-gray">ชื่อ - นามสกุล: </span>
                            <span class="ra-head-text black--text">{{ item.approverName }}</span>
                          </v-col>
                          <v-col cols="12" lg="5" md="5" sm="5" class="ma-0 pb-0">
                            <span class="ra-head-text-gray">อีเมล: </span>
                            <span class="ra-head-text black--text">{{ item.email || item.emailOneId }}</span>
                          </v-col>
                          <v-col cols="12" lg="7" md="7" sm="7" class="ma-0 pb-2">
                            <span class="ra-head-text-gray">ตำแหน่ง: </span>
                            <span class="ra-head-text black--text">{{ item.position }}</span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-row>
      </v-container>
    </v-card>
    <v-dialog v-model="dialogConfirmSubmit" max-width="500px">
      <v-card height="180px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการบันทึกข้อมูลใช่ไหม</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการบันทึกข้อมูล</span>
        <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirmSubmit = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="submitDataCreate()">บันทึกข้อมูล</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-row>
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          text
          top
          app
          class="content-alert"
        >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </v-row>
    </div>
  </div>
</template>

<script>
import {
  // getUserByKeyword,
  // editService,
  getDetailTokenById,
  // getCompanySelector,
  // getChartPickerSelector,
  updateExternalToken,
  hostImageUrlv3
} from '@/API/API'
import swal from 'sweetalert'
import { EventBus } from '@/EventBus'
// import FullLoading from '../../_template/FullLoading.vue'

export default {
  components: {
  },
  name: 'showServiceDetail',
  data () {
    return {
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogShow: false,
      promtDialog: false,
      dialogConfirmSubmit: false,
      serviceName: '',
      urlName: '',
      server: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}`,
      reqType: 'Service',
      selectedService: '',
      note: '',
      approvers: [],
      itemsReqType: [],
      itemsServiceList: [],
      itemsApprovers: [],
      token: 'xxxxx',
      approveRole: localStorage.approveRole,
      dataSource: [],
      editMode: false
    }
  },
  mounted () {
    EventBus.$on('setApproveRole', this.setApproveRole)
  },
  beforeDestroy () {
    EventBus.$off('setApproveRole')
  },
  created () {
    this.initDataToken(this.$route.params.id)
  },
  computed: {
  },
  watch: {
  },
  methods: {
    goBack () {
      this.$router.push('/manageapprovetoken')
    },
    async setApproveRole () {
      this.approveRole = localStorage.approveRole
    },
    async changeMode () {
      if (this.editMode === false) {
        this.editMode = true
        // await this.getCompanyDetail(this.reqBusinessId)
      } else {
        this.editMode = false
        this.initDataToken(this.$route.params.id)
      }
    },
    copyToken () {
      const clipboardData =
        event.clipboardData ||
        window.clipboardData ||
        event.originalEvent?.clipboardData ||
        navigator.clipboard
      clipboardData.writeText(this.token)
      this.text = 'ทำการคัดลอก Token เรียบร้อยแล้ว'
      this.snackbarColor = 'success'
      this.snackbar = true
    },
    async initDataToken (id) {
      const tempMember = []
      this.dataSource = []
      this.approver = []
      this.loadingInit = true
      const payload = { tokenId: id }
      try {
        const res = await getDetailTokenById(this.$store.state.token, payload)
        if (res.success) {
          console.log(res)
          this.dataSource = res.result
          if (this.dataSource) {
            this.approvers = this.dataSource.approver || []
            this.approvers.forEach(e => {
              e.userImg = `${hostImageUrlv3}/_/${e.email || e.emailOneId}`
            })
            // this.approvers.push({

            // })
            // res.result.userData.map((el, index) => {
            // if (el.memberImg === '') {
            //   el.memberImg = `${hostImageUrlv3}/_/${el.emailOneId}`
            // } else {
            //   el.memberImg = `${hostImageUrlv3}/${el.memberImg}/${el.emailOneId}`
            // }
            tempMember.push({
              // approverNo: index + 1,
              approverName: res.result.userData.titleTh + res.result.userData.firstNameTh + ' ' + res.result.userData.lastNameTh,
              email: res.result.userData.emailOne,
              userImg: `${hostImageUrlv3}/_/${res.result.userData.emailOne}`,
              position: res.result.userData.positionName,
              failed_image: false,
              ...res.result.userData
            })
            this.approvers = tempMember
            // })
            this.token = this.dataSource.token
          } else {
            this.approvers = []
          }
        } else {
          this.dataSource = []
          this.approvers = []
        }
      } catch (error) {
        this.dataSource = []
        this.approvers = []
        console.log(error)
      } finally {
        self.loadingInit = false
      }
    },
    async submitDataCreate () {
      this.loading = true
      this.loadingUsers = true
      const obj = {
        tokenId: this.$route.params.id,
        comment: this.dataSource.comment,
        projectName: this.dataSource.projectName
      }
      if (this.dataSource.projectName === '' || this.dataSource.comment === '') {
        swal('คำเตือน', 'กรุณากรอกข้อมูลให้ครบ', 'warning')
      } else {
        try {
          const res = await updateExternalToken(obj, this.tokenUser)
          if (res.success) {
            swal('สำเร็จ', 'แก้ไขข้อมูล เรียบร้อยแล้ว', 'success', {
              button: false,
              timer: 2000
            })
            this.dialogConfirmSubmit = false
            this.goBack()
          }
        } catch (error) {
          console.log(error)
          swal('ผิดหลาด', 'สร้างใบร้องขอ ไม่สำเร็จ', 'success', {
            button: false,
            timer: 2000
          })
        } finally {
          this.loading = false
          this.loadingUsers = false
        }
      }
    }
  }
}
</script>
<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  color: #2BA197;
}
.base-image-input {
  display: block;
  width: 100px;
  height: 100px;
  /* padding: 8%; */
  border-radius: 5px;
  cursor: pointer;
  background-size: contain;
  background-position: center center;
}
/* src\assets\logo.png */
/* '@/assets/icons/no_user.png' */
/* src\assets\icons\no_user.png */
.placeholder-image {
  /* background: #F0F0F0; */
  background-image: url('../../../assets/icons/no-company-7.png');
  width: 100%;
  height: 100%;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-family: 'Sarabun', sans-serif;
}
.placeholder:hover {
  /* background: #E0E0E0; */
  background-image: url('../../../assets/icons/no-company-7.png');

}
.file-input {
  display: none;
}
.box-image1 {
  border: 1px solid rgba(0, 0, 0, 0.4);
  outline: none;
  color: rgb(118, 118, 118);
  /* display: flex; */
  align-content: center;
  justify-content: center;
  display: grid;
  height: 70%;
  text-align: center;
}
.box-image2 {
  border: dashed;
  border-width: 1px 1px;
  border-radius: 10px;
}
.button {
  border: none;
  color: white;
  /* padding: 15px 32px; */
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;

}
label {
  background-color: indigo;
  color: white;
  /* padding: 0.5rem; */
  padding: 0.7rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
}
/* upfile pdf */
div.file-listing{
  width: 800px;
}
input[type="file"]{
  position: absolute;
  top: -500px;
  display:none;
}

  /* อัปโหลดไฟล์ */
  .upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn_click {
  border: 2px solid gray;
  /* color: gray; */
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #2BA197;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}
.ra-span-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #757575;
}
.snack-content {
  min-width: 60px !important;
  max-width: 70px !important;
}
.content-alert >>> .v-snack__wrapper {
  min-width: 15px !important;
}
</style>
